function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.828 9.024a3.2 3.2 0 012.344 0l12.17 4.79a.2.2 0 010 .372l-12.17 4.79a3.2 3.2 0 01-2.344 0l-12.17-4.79a.2.2 0 010-.372l12.17-4.79z",
  stroke: "#1F3970",
  strokeWidth: 1.6
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16v4.454C8 21.86 11.582 23 16 23s8-1.14 8-2.546V16M5 14v6",
  stroke: "#1F3970",
  strokeWidth: 1.6
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 21,
  r: 1,
  stroke: "#1F3970",
  strokeWidth: 1.6
});

var SvgIconStudent = function SvgIconStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjgyOCA5LjAyMzU4QzE1LjU4MTIgOC43MjcxMiAxNi40MTg4IDguNzI3MTIgMTcuMTcyIDkuMDIzNThMMjkuMzQyOCAxMy44MTM5QzI5LjUxMTggMTMuODgwNCAyOS41MTE4IDE0LjExOTYgMjkuMzQyOCAxNC4xODYxTDE3LjE3MiAxOC45NzY0QzE2LjQxODggMTkuMjcyOSAxNS41ODEyIDE5LjI3MjkgMTQuODI4IDE4Ljk3NjRMMi42NTcxOCAxNC4xODYxQzIuNDg4MTggMTQuMTE5NiAyLjQ4ODE4IDEzLjg4MDQgMi42NTcxOCAxMy44MTM5TDE0LjgyOCA5LjAyMzU4WiIgc3Ryb2tlPSIjMUYzOTcwIiBzdHJva2Utd2lkdGg9IjEuNiIvPgo8cGF0aCBkPSJNOCAxNlYyMC40NTQ1QzggMjEuODYwNCAxMS41ODE3IDIzIDE2IDIzQzIwLjQxODMgMjMgMjQgMjEuODYwNCAyNCAyMC40NTQ1VjE2IiBzdHJva2U9IiMxRjM5NzAiIHN0cm9rZS13aWR0aD0iMS42Ii8+CjxwYXRoIGQ9Ik01IDE0VjIwIiBzdHJva2U9IiMxRjM5NzAiIHN0cm9rZS13aWR0aD0iMS42Ii8+CjxjaXJjbGUgY3g9IjUiIGN5PSIyMSIgcj0iMSIgc3Ryb2tlPSIjMUYzOTcwIiBzdHJva2Utd2lkdGg9IjEuNiIvPgo8L3N2Zz4K";
export { SvgIconStudent as ReactComponent };